import ExpandedSection from './ExpandedSection';
import { toTestIdPart } from '../../utils/testIds';
import './terpenesSection.css';

type TerpeneRow = {
  terpene: string;
  percent: string;
  emphasized?: boolean;
  reportedAmount?: boolean;
};

type TerpenesSectionProps = {
  chevronSrc: string;
  rows: TerpeneRow[];
};

export default function TerpenesSection({ chevronSrc, rows }: TerpenesSectionProps) {
  return (
    <ExpandedSection title="Terpenes" chevronSrc={chevronSrc} testId="landing-terpenes-toggle">
      <table className="rid-terpenes__table" data-testid="landing-terpenes-table">
        <thead>
          <tr>
            <th>Terpene</th>
            <th>{rows.some(row => row.reportedAmount) ? 'Result' : 'Percent'}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            const rowId = toTestIdPart(row.terpene, 'terpene');
            return (
              <tr key={row.terpene} className={row.emphasized ? 'rid-terpenes__row-emphasis' : ''} data-testid={`landing-terpene-row-${rowId}`}>
                <td data-testid={`landing-terpene-name-${rowId}`}>{row.terpene}</td>
                <td data-testid={`landing-terpene-percent-${rowId}`}>{row.percent}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </ExpandedSection>
  );
}
